import React from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn as isLoggedInSelector } from 'selectors/accountSelectors'
import LoggedOutTripPlannerLandingPage from './LoggedOutTripPlannerLandingPage'
import LoggedInTripPlannerLandingPage from './LoggedInTripPlannerLandingPage'

function TripPlannerLandingPage() {
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  if (!isLoggedIn) {
    return <LoggedOutTripPlannerLandingPage />
  }
  return <LoggedInTripPlannerLandingPage />
}

export default TripPlannerLandingPage
